var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"dropdown-item text-truncate",attrs:{"href":"#"}},[_vm._v("\n    "+_vm._s(_vm.item.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }